import { render, staticRenderFns } from "./ShareBasketFormModal.vue?vue&type=template&id=3782cde8"
import script from "./ShareBasketFormModal.vue?vue&type=script&lang=js"
export * from "./ShareBasketFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports